import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

// CHANGED 'scores' to 'evaluationData' to match the parent prop and your internal logic
export function ResultsTab({ data, evaluationData, legendDefinitions }) {

  const calculateFinalScore = () => {
    let total = 0;
    if (!evaluationData || Object.keys(evaluationData).length === 0) return "0.00";

    data.performanceCategories.forEach(cat => {
      cat.objectives.forEach(obj => {
        // Ensure we handle both strings and numbers from the state
        const item = evaluationData[obj.id];
        const score = item ? parseFloat(item.score) : 0;
        total += (score * (obj.percentage / 100));
      });
    });
    return total.toFixed(2);
  };

  const finalScore = calculateFinalScore();

  const getInterpretation = () => {
    const scoreNum = parseFloat(finalScore);
    if (scoreNum <= 0) return { code: "Incomplete", desc: "Please rate all objectives.", color: "text-gray-400" };

    // Sort legends from highest rating to lowest
    const sorted = [...legendDefinitions].sort((a, b) => b.rating - a.rating);

    // Find matching interpretation
    const match = sorted.find(l => scoreNum >= l.rating) || sorted[sorted.length - 1];

    return {
      code: match?.code,
      desc: match?.description,
      color: "text-blue-600"
    };
  };

  const result = getInterpretation();

  return (
    <div className="flex flex-col items-center py-10 space-y-8">
      <div className="text-center space-y-2">
        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">Final Weighted Score</p>
        <div className="text-9xl font-black text-blue-500 drop-shadow-md">
          {finalScore}
        </div>
      </div>

      <div className="w-full max-w-2xl bg-white border border-gray-200 rounded-2xl p-10 text-center shadow-sm relative">
        <div className="absolute -top-2 left-1/2 -translate-x-1/2 bg-blue-600 text-white px-6 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest">
          Performance Rating
        </div>
        <WorkspacePremiumIcon className="text-blue-400 mb-4" sx={{ fontSize: 50 }} />

        <h4 className={`text-3xl font-bold mb-3 ${result.color}`}>
          {result.code}
        </h4>

        <p className="text-gray-600 italic text-sm px-10">"{result.desc}"</p>
      </div>

      <div className="flex space-x-6">
        <div className="flex items-center space-x-2 text-green-600 font-bold">
          <CheckCircleIcon fontSize="small" />
          <span className="text-sm">Calculation Validated</span>
        </div>
      </div>
    </div>
  );
}